(function () {
  function init() {
    gsap.registerPlugin(ScrollTrigger)

    const thresholds = [0.044, 0.057, 0.235, 0.366, 0.395, 0.574, 0.823, 0.919, 0.962]

    const mm = gsap.matchMedia()

    mm.add('(min-width: 769px)', function () {
      document.querySelectorAll('.story-map').forEach(function (section) {
        const fillPath = section.querySelector('.story-map__road-fill')
        if (!fillPath) return

        const length = fillPath.getTotalLength()
        const keypoints = section.querySelectorAll('.story-map__keypoint')
        const images = section.querySelectorAll('.story__image')

        gsap.set(fillPath, {
          strokeDasharray: length,
          strokeDashoffset: length
        })

        gsap.to(fillPath, {
          strokeDashoffset: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: '20% bottom',
            end: '110% bottom',
            scrub: 1.05,
            onUpdate: function (self) {
              keypoints.forEach(function (point, i) {
                self.progress > thresholds[i]
                  ? point.classList.add('shown')
                  : point.classList.remove('shown')
              })
            }
          }
        })

        gsap.from(images, {
          rotate: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1.05
          }
        })
      })
    })
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init()
  } else {
    window.addEventListener('load', init)
  }
})()
